var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-code",on:{"click":_vm.generate}},_vm._l((_vm.codeCount),function(c,i){return _c('span',{key:i,style:({color: _vm.getColor(), fontWeight: _vm.getWeight(), fontStyle: _vm.getStyle(), marginRight: _vm.getRight()})},[_vm._v(_vm._s(_vm.codeChars.charAt(_vm.codeIndex[i])))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fe2e172","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyCode.vue
// module id = null
// module chunks = 